import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback, useMemo } from 'react';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import GridCellBase from '../GridCellBase';
import ExpandCollapseCell from './ExpandCollapseCell';

const CommittedAmountDetailColumnCell = (props: GridCellProps) => {
  let { expanded = false } = props.dataItem;
  const { dataItem } = props;
  const { setCommittedAmountData } = useViewCheckbook();
  const handleExpendClick = useCallback(() => {
    setCommittedAmountData((pre) =>
      pre.map((action) => ({
        ...action,
        expanded: action.rowId === dataItem.rowId ? !dataItem.expanded : action.expanded,
      }))
    );
  }, [dataItem.expanded, dataItem.rowId, setCommittedAmountData]);
  const lastRow = useMemo(() => dataItem.rowId === 'noExpand', [dataItem.rowId]);

  return (
    <GridCellBase {...props} className="k-hierarchy-cell" disableToolTip>
      {!lastRow && (
        <ExpandCollapseCell
          title="Expand/Collapse"
          expand={expanded}
          onExpand={handleExpendClick}
          plusIconColor="#0e80b4"
          minusIconColor="#0e80b4"
        />
      )}
    </GridCellBase>
  );
};

export default CommittedAmountDetailColumnCell;
